var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "search-bar-margin-bottom-cla" }, [
        _c("div", { staticClass: "goBack", on: { click: _vm.goBack } }, [
          _c("i", { staticClass: "goback-icon-cla" }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("developer.goback")))])
        ])
      ]),
      _vm._v(" "),
      _c("zkThreeRow", [
        _c(
          "div",
          {
            staticStyle: {
              height: "100px",
              display: "flex",
              "align-items": "center"
            },
            attrs: { slot: "search" },
            slot: "search"
          },
          [
            _c(
              "el-upload",
              {
                staticClass: "upload-demo",
                attrs: {
                  action: "/apiv1/hr/company/uploadCompanyLogo",
                  "show-file-list": false,
                  data: _vm.datas,
                  "on-success": _vm.handleAvatarSuccess,
                  "on-error": _vm.uploadError,
                  "before-upload": _vm.beforeAvatarUpload
                }
              },
              [
                _vm.imgUrl
                  ? _c("img", {
                      staticClass: "avatar",
                      attrs: { src: _vm.imgUrl }
                    })
                  : _c("div", { staticClass: "upload_div" }, [
                      _c("i", { staticClass: "el-icon-plus el-icon-upload" })
                    ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { padding: "0 20px" } }, [
              _c("span", { staticStyle: { "font-weight": "700" } }, [
                _vm._v(_vm._s(_vm.companyDetails.companyName) + "\n          "),
                _c("i", {
                  staticClass: "el-icon-edit edit_company",
                  on: { click: _vm.editCompany }
                })
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "200px",
                      color: "#cccccc",
                      "font-size": "14px",
                      "line-height": "16px"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("company.industry")) +
                        ":" +
                        _vm._s(_vm.companyDetails.industry)
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      color: "#cccccc",
                      "font-size": "14px",
                      "line-height": "16px"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("company.webSite")) +
                        ":" +
                        _vm._s(_vm.companyDetails.website)
                    )
                  ]
                )
              ])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { slot: "table" }, slot: "table" },
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName"
                }
              },
              [
                _c(
                  "el-tab-pane",
                  { attrs: { name: "1", label: _vm.$t("company.cmpInfo") } },
                  [
                    _vm.activeName === "1"
                      ? _c("companyInformaion", {
                          attrs: {
                            companyDetailsInfo: _vm.companyDetails,
                            contryCode: _vm.contryCode
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isShowAdminAccount !== 0
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          name: "4",
                          label: _vm.$t("user.accountByLogin")
                        }
                      },
                      [
                        _vm.activeName === "4"
                          ? _c("adminAccount", {
                              attrs: { currentRow: _vm.companyDetails }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  { attrs: { name: "3", label: _vm.$t("company.devList") } },
                  [
                    _vm.activeName === "3"
                      ? _c("companyDevice", {
                          staticStyle: { "margin-top": "5px" },
                          attrs: {
                            companyDevice: _vm.companyDetails,
                            isCmpDevice: true
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  {
                    attrs: { name: "5", label: _vm.$t("company.employeeList") }
                  },
                  [
                    _vm.activeName === "5"
                      ? _c("companyEmployee", {
                          attrs: { currentRow: _vm.companyDetails }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("company.updateInfo"),
            visible: _vm.dialogVisible,
            width: "50%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "companyDetailsForm",
              attrs: {
                model: _vm.copyDetails,
                "label-width": "160px",
                rules: _vm.rules
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("tenant.owner"), prop: "companyName" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.copyDetails.companyName,
                      callback: function($$v) {
                        _vm.$set(_vm.copyDetails, "companyName", $$v)
                      },
                      expression: "copyDetails.companyName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("company.webSite") } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.copyDetails.website,
                      callback: function($$v) {
                        _vm.$set(_vm.copyDetails, "website", $$v)
                      },
                      expression: "copyDetails.website"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("company.industry") } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.copyDetails.industry,
                      callback: function($$v) {
                        _vm.$set(_vm.copyDetails, "industry", $$v)
                      },
                      expression: "copyDetails.industry"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: this.$t("company.Contact"), prop: "name" } },
                [
                  _c("el-input", {
                    staticClass: "contact_input",
                    attrs: { placeholder: this.$t("user.inputName") },
                    model: {
                      value: _vm.copyDetails.formattedName,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.copyDetails,
                          "formattedName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "copyDetails.formattedName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: this.$t("company.country"),
                    prop: "countryCode"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { filterable: "", placeholder: "" },
                      on: { change: _vm.changeCountry },
                      model: {
                        value: _vm.copyDetails.countryCode,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.copyDetails,
                            "countryCode",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "copyDetails.countryCode"
                      }
                    },
                    _vm._l(_vm.contryCode, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.key, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item-cla flex-item-cla",
                  attrs: { label: this.$t("company.phone"), prop: "phone" }
                },
                [
                  _c(
                    "el-input",
                    {
                      model: {
                        value: _vm.copyDetails.phone,
                        callback: function($$v) {
                          _vm.$set(_vm.copyDetails, "phone", $$v)
                        },
                        expression: "copyDetails.phone"
                      }
                    },
                    [
                      _c("template", { slot: "prepend" }, [
                        _vm._v("+" + _vm._s(_vm.phonePrefix))
                      ])
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticClass: "form-item-cla flex-item-cla",
                  attrs: { label: this.$t("company.email"), prop: "email" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.copyDetails.email,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.copyDetails,
                          "email",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "copyDetails.email"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("common.cancel")))
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sumbitEdit } },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-618019a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-618019a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tenantManager/companyInfo/companyDetail.vue
// module id = null
// module chunks = 